import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitWeeklyReport, WeeklyReportPeriod } from '@/services/api/requests/weekly-report';
import { WeeklyReportDraft } from '@/modules/peer-support/weekly-report/model/types';
import { weeklyReportQueryKey } from './useWeeklyReportPeriod';
import { useAuthContext } from '@/context/auth/useAuthContext';

const useSubmitWeeklyReport = (period: string | undefined, draft: WeeklyReportDraft, token?: string) => {
  const { user } = useAuthContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      if (!period) throw new Error('A reporting period is required to submit a weekly report.');
      return submitWeeklyReport(period, draft, token);
    },
    onSuccess: () => {
      if (token) {
        queryClient.setQueryData<WeeklyReportPeriod>(weeklyReportQueryKey(period, token, user?.user_id), (previous) =>
          previous ? { ...previous, status: 'already-submitted' } : previous,
        );
        return;
      }
      queryClient.setQueriesData<WeeklyReportPeriod>({ queryKey: ['weekly-report'] }, (previous) =>
        previous && previous.periodStart === period ? { ...previous, status: 'already-submitted' } : previous,
      );
    },
  });
};

export default useSubmitWeeklyReport;
